<div>
  @let title = 'Listado de Onus Autorizadas'; @let subTitle = '';
  <!-- @let subTitle =  dialog?.data?.data ? 'Nº Total de facturas:' + dialog?.data?.data?.length + ' <br>total Usd:' + (getTotal('total', dialog?.data?.data) | currency) + ' <br>total Bs:' + (getTotal('bs', dialog?.data?.data) | numberFormat) : ''; -->
  <input
    id="search-tbl-detail-bills-aggrouped"
    type="text"
    pInputText
    placeholder="Buscar..."
    (keyup)="search('tbl-detail-bills-aggrouped', 'search-tbl-detail-bills-aggrouped')"
    class="p-inputtext p-component" />
  <button
    class="float-end h-8 w-8"
    pButton
    type="button"
    icon="pi pi-print"
    severity="info"
    (click)="print('tbl-detail-bills-aggrouped', title, subTitle)"></button>
  <button
    class="p-button-success float-end mr-2 h-8 w-8"
    pButton
    type="button"
    icon="pi pi-file-excel"
    (click)="exportDataService.exportExcel(this.data.onus, title)"></button>
</div>
<div class="overflow-x-auto">
  <table id="tbl-detail-bills-aggrouped" aria-hidden="true" class="min-w-full bg-white">
    <thead>
      <tr>
        <th scope="col" class="border-b-2 border-blue-400 px-4 py-2 text-left">Nº</th>
        <th scope="col" class="border-b-2 border-blue-400 px-4 py-2 text-left">Cliente</th>
        <th scope="col" class="border-b-2 border-blue-400 px-4 py-2 text-left">Nº serial olt</th>
        <th scope="col" class="border-b-2 border-blue-400 px-4 py-2 text-left">ONU</th>
        <th scope="col" class="truncate border-b-2 border-blue-400 px-4 py-2 text-left">Zona</th>
        <th scope="col" class="truncate border-b-2 border-blue-400 px-4 py-2 text-left">ODB</th>
        <th scope="col" class="truncate border-b-2 border-blue-400 px-4 py-2 text-left">Estatus</th>

        <th scope="col" class="truncate border-b-2 border-blue-400 px-4 py-2 text-left">B/R</th>
        <th scope="col" class="truncate border-b-2 border-blue-400 px-4 py-2 text-left">VLAN</th>
        <th scope="col" class="truncate border-b-2 border-blue-400 px-4 py-2 text-left">VoIP</th>
        <th scope="col" class="truncate border-b-2 border-blue-400 px-4 py-2 text-left">Tipo</th>
        <th scope="col" class="truncate border-b-2 border-blue-400 px-4 py-2 text-left">Fecha de autorización</th>
      </tr>
    </thead>
    <tbody>
      @for (item of this.data.onus; track item.id; let i=$index) {

      <tr class="hover:bg-gray-100">
        <td class="border-b border-gray-300 px-4 py-2">{{ i + 1 }}</td>
        <td class="whitespace-nowrap border-b border-gray-300 px-4 py-2">{{ item.name }}</td>
        <td class="whitespace-nowrap border-b border-gray-300 px-4 py-2">{{ item.sn_mac }}</td>
        <td class="whitespace-nowrap border-b border-gray-300 px-4 py-2">{{ item.onu }}</td>
        <td class="whitespace-nowrap border-b border-gray-300 px-4 py-2">{{ item.zone }}</td>
        <td class="whitespace-nowrap border-b border-gray-300 px-4 py-2">{{ item.odb }}</td>
        <td class="whitespace-nowrap border-b border-gray-300 px-4 py-2">{{ item.status }}</td>

        <td class="whitespace-nowrap border-b border-gray-300 px-4 py-2">{{ item.mode }}</td>
        <td class="whitespace-nowrap border-b border-gray-300 px-4 py-2">{{ item.vlan }}</td>
        <td class="whitespace-nowrap border-b border-gray-300 px-4 py-2">{{ item.voip }}</td>
        <td class="whitespace-nowrap border-b border-gray-300 px-4 py-2">{{ item.type }}</td>
        <td class="whitespace-nowrap border-b border-gray-300 px-4 py-2">{{ item.auth_date }}</td>
      </tr>
      } @if(this.data.onus.length > 0){
      <tr>
        <td colspan="1"></td>
        <td>Total autorizadas: {{ this.data.total_onus }}</td>
        <td colspan="11"></td>
      </tr>
      } @if(this.data.onus.length === 0){
      <tr>
        <td class="border-b border-gray-300 px-4 py-2 text-center" colspan="12">No se encontraron registros.</td>
      </tr>
      }
    </tbody>
  </table>
</div>
